import type { MonospaceSingleRelationField, MonospaceSingleRelationFieldMeta } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

interface StudioSingleRelationField extends MonospaceSingleRelationField {
	isStudioOnly?: boolean;
}

export const SingleRelationField = withItemType<StudioSingleRelationField>().defineCollection({
	name: 'MonospaceSingleRelationField',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: ['id', 'apiName', 'isNullable', 'isList', 'oppositeCollectionId', 'collectionId', 'constraintId', 'oppositeRelationFieldId'],
	},
});

export const SingleRelationFieldMeta = withItemType<MonospaceSingleRelationFieldMeta>().defineCollection({
	name: 'MonospaceSingleRelationFieldMeta',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.fieldId,
	meta: {
		defaultFields: ['fieldId', 'description', 'typeTemplateId', 'typeOptions', 'inputId', 'inputOptions', 'displayId', 'displayName', 'displayOptions', 'isHidden', 'sort', 'oppositeJunctionRelationFieldId'],
		connect: {
			fieldId: ['field', 'id'],
		},
	},
});
